import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const SidebarContext = createContext();

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
};

export const SidebarProvider = ({ children, shouldShowSidebar = true }) => {
    const [isSidebarShown, setIsSidebarShown] = useState(() => {
        const saved = Cookies.get('sidebarShown');
        return saved ? saved === 'true' : shouldShowSidebar;
    });

    useEffect(() => {
        Cookies.set('sidebarShown', isSidebarShown);
    }, [isSidebarShown]);

    const toggleSidebar = () => {
        setIsSidebarShown((prev) => !prev);
    };

    return (
        <SidebarContext.Provider value={{ isSidebarShown, toggleSidebar }}>
            {children}
        </SidebarContext.Provider>
    );
};
